export default __webpack_public_path__ + "static/media/Tralexho-O.a5e1aba1.svg";